import ProductSamplingInventoryMaintenance from '../pages/ProductSamplingInventoryMaintenance';

const productSamplingInventory = {
  public: [],
  auth: [
    {
      name: 'product_sampling_inventory_maintenance',
      path: '/maintenance/product-sampling-inventory',
      permissions: ['PM', 'PRODUCT MANAGER', 'GPM'],
      component: ProductSamplingInventoryMaintenance,
    },
  ],
};

export default productSamplingInventory;
